import React from 'react'

import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import FileUploaderV2List from '@core/components/ApplyDialogV2/FileUploaderV2List'
import { getApplyFilePreviewAuth, useFilePreviewSession } from '@core/components/FilePreview'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { useFilePreview } from '@core/utils/contexts/FilePreviewContext/FilePreviewContext'

import './ApplyV2ReviewApplyCv.scss'

interface ApplyV2ReviewApplyCv {
    className?: string
}

const baseClass = 'ApplyV2ReviewApplyCv'

function ApplyV2ReviewApplyCv({ className = '' }: ApplyV2ReviewApplyCv) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        settingsData,
    } = useApplyV2Context()
    const { t } = useTranslation()
    const { openPreview } = useFilePreview()
    const { openFilePreview } = useFilePreviewSession()
    const profileData = postProfileData?.data?.cv
    if (!profileData) {
        return (
            <div
                className={clsx(baseClass, className, {
                    [`${baseClass}--isEmpty`]: true,
                })}
            >
                {t('10699', 'No CV uploaded')}
            </div>
        )
    }
    return (
        <div className={`${baseClass} ${className}`}>
            <FileUploaderV2List
                files={profileData ? [profileData] : []}
                isShowDelete={false}
                isShowParseInfo={false}
                onFileClick={(f) => {
                    const previewAuth = getApplyFilePreviewAuth(f, postProfileData?.data?.uid)
                    if (previewAuth) {
                        openFilePreview(previewAuth)
                    } else {
                        openPreview(
                            {
                                Filename: f.name,
                                Ext: f.ext,
                                CandidateFileID: f.existingId,
                                downloadUrl: f.downloadUrl,
                                Size: f.size,
                                ...f,
                                uid: postProfileData?.data?.uid ?? '',
                                fileUid: f.uid,
                                type: f.type,
                            },
                            f.folder
                        )
                    }
                }}
            ></FileUploaderV2List>
        </div>
    )
}

export default ApplyV2ReviewApplyCv
